import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function fetchUsersList() {
  const response = await getAPIResponse("/v1/user-list?offset=0&limit=5000&filterEnabled=1", null, "GET");
  return response?.records || [];
}
